import React, { FC, ReactNode } from 'react';
import { Typography } from '@material-ui/core';
import { BoxProps } from '@material-ui/core/Box';
import { PrefixWrapper, TitleWrapper } from './Atoms';

type Props = Omit<BoxProps, 'prefix'> & {
  prefix?: ReactNode;
  className?: string;
  forceInline?: boolean;
};

const PageTitle: FC<Props> = ({ prefix, children, forceInline = false, className }) => {
  return (
    <TitleWrapper className={`${className && className} ${forceInline ? 'force-inline' : ''}`}>
      {prefix && <PrefixWrapper>{prefix}</PrefixWrapper>}
      <Typography variant="h1">{children}</Typography>
    </TitleWrapper>
  );
};

export default PageTitle;
